export default {
    methods: {
        priceFormatted(price) {
            const decimalStr = price.toString().split('.')[1];
            if (decimalStr && decimalStr.length !== this.numberOfDecimals && decimalStr === '00') {
                if (this.numberOfDecimals === 0) {
                    return price.toString().split('.')[0];
                }
            }

            if (decimalStr && decimalStr.length === 1 && this.numberOfDecimals === 2) {
                return (price.toString() + '0').replace('.', '<span class="dec-point">,</span>');
            }

            return price.toString().replace('.', '<span class="dec-point">,</span>');
        },
    },
};
